import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ANALYTICS, BULK_UPLOAD, COMMON_CONSTANTS } from 'src/app/common/core/common.constants';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { PDLService } from 'src/app/services/pdl-service.service';
import { UtilsService } from 'src/app/services/utils.service';
import { isNullOrUndefined } from 'src/app/services/utils';

@Component({
  selector: 'app-download-managelines-modal',
  templateUrl: './download-managelines-modal.component.html',
  styleUrls: ['./download-managelines-modal.component.scss']
})
export class DownloadManagelinesModalComponent implements OnInit {
  isGlossary: boolean;
  authoringContentData: any;
  header: any;
  content: any;
  excelType: any;
  isActiveChbxSelected = false;
  isOpenedFromAccntLstPage: any;
  showActiveLineOptn = false;
  noDwnldButton : boolean = true;
  @Output() csvDownload = new EventEmitter();

  constructor(public manageLineService: ManageLineService, public utilsSvc: UtilsService, private pdlService: PDLService) { }

  ngOnInit() {
    this.excelType = '';
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();
    HttpCacheService.SetCache(BULK_UPLOAD.IS_ACTIVE_SELECTED, this.isActiveChbxSelected);
    if (this.isOpenedFromAccntLstPage) {
      this.showActiveLineOptn = true;
    }

    this.pdlService.ifEnabledGenerateModalViewTag({
      eventAction: ANALYTICS.LOAD,
      modalName: ANALYTICS.DOWNLOAD_LINE_DETAILS
    });
  }

  onClickActive(event?) {
    if (isNullOrUndefined(event)) {
      this.isActiveChbxSelected = !this.isActiveChbxSelected;
    }
    HttpCacheService.SetCache(BULK_UPLOAD.IS_ACTIVE_SELECTED, this.isActiveChbxSelected);
  }

  downloadCsv() {
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.CSV_FILE_FORMAT,
      assetType: ANALYTICS.BUTTON,
      modalName: ANALYTICS.DOWNLOAD_LINE_DETAILS
    });
    this.excelType = BULK_UPLOAD.CSV_TXT;
    this.csvDownload.emit(this.excelType);
  }

  downloadExcel() {
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.XLS_FILE_FORMAT,
      assetType: ANALYTICS.BUTTON,
      modalName: ANALYTICS.DOWNLOAD_LINE_DETAILS
    });
    this.excelType = BULK_UPLOAD.XLSX_TXT;
    this.csvDownload.emit(this.excelType);
  }

  closeModal() {
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: COMMON_CONSTANTS.CLOSE,
      assetType: ANALYTICS.BUTTON,
      modalName: ANALYTICS.DOWNLOAD_LINE_DETAILS
    });
    this.manageLineService.close()
  }

}
